import { useCallback, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { setTimeout } from "timers";
import { useQuery } from "../../../hooks";
import { api } from "../../../utils/api";

const Redirection = (): JSX.Element => {
	const query = useQuery();
	const history = useHistory();

	const verifyRedirection = useCallback(async () => {
		if (query && query.get("id") && query.get("token")) {
			// console.log("id", query.get("id"), "tokens", query.get("token"));
			const result = await api.redirection.redirectUser(query.get("id") as string, query.get("token") as string);
			localStorage.clear();
			if (query.get("is_emp")) {
				localStorage.removeItem("@jwt_group_owner");
			} else {
				localStorage.setItem("@jwt_group_owner", query.get("token") as string);
			}

			localStorage.setItem("@jwt_member", result.token as string);
			localStorage.setItem("@role", result.role);
			// setTimeout(() => null, 3000);
			setTimeout(() => {
				history.push("/");
			}, 2000);
		}
	}, [query, history]);

	useEffect(() => {
		//alert("hi");
		localStorage.clear();
		verifyRedirection();
	}, [verifyRedirection]);

	return <>Redirecting...</>;
};

export default Redirection;
